import { render, staticRenderFns } from "./NewsTabsCarousel.vue?vue&type=template&id=2c27a780&scoped=true"
import script from "./NewsTabsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsTabsCarousel.vue?vue&type=script&lang=js"
import style0 from "./NewsTabsCarousel.vue?vue&type=style&index=0&id=2c27a780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27a780",
  null
  
)

export default component.exports